import axios from "axios";
// axios config for export xls format data
export const xlsApi = axios.create({
  //baseURL:"http://216.117.177.3:5000",
  //baseURL:"http://208.234.30.132:5000",
  baseURL:"https://awards.matchforce.org/",
  responseType: "arraybuffer"
});

